import React from "react";
import { useTranslation } from "react-i18next";
import article from "../assets/images/IMG_4097.JPG";

const Article = () => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 pt-14">
      <div className="bg-[#fbfbfb] col-span-1">
        <img
          src={article}
          alt=""
          className="w-full lg:w-[100%] h-[280px] sm:h-[420px] lg:h-[800px] object-contain"
        />
      </div>
      <div className="flex justify-center items-center w-full col-span-1">
        <div className="p-6 sm:p-10 lg:p-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 text-[#223746] lg:w-2/3">
            {t("article.title")}
          </h2>
          <p className="mt-5 text-[#223746] text-sm sm:text-base">
            {t("article.body")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Article;
